import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Chinese%20football%20stadium%20with%20dramatic%20floodlight%20illumination%2C%20empty%20green%20pitch%20with%20red%20accents%2C%20atmospheric%20mist%2C%20heroic%20sports%20atmosphere%2C%20professional%20stadium%20photography%2C%20warm%20golden%20and%20red%20tones%2C%20epic%20scale%2C%20cinematic%20lighting&width=1800&height=900&seq=hero-haohaidong&orientation=landscape"
        alt="郝海东——中国足球传奇前锋"
        className="absolute inset-0 w-full h-full object-cover object-top"
        title="郝海东——中国足球传奇前锋官方介绍页"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>
      <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-4 w-full">
        <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-black text-white mb-3 tracking-wider">
          郝海东
        </h1>
        <p className="text-lg md:text-2xl text-white/90 font-label mb-4 tracking-wide">
          中国足球传奇前锋
        </p>
        <p className="text-sm md:text-base text-white/70 max-w-xl leading-relaxed">
          96粒顶级联赛进球 · 107场国家队出战 · 18年职业生涯 · 中国足球史上最具标志性的前锋
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-3 mt-8">
          <Link
            to="/category/goals"
            className="px-8 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-semibold hover:bg-primary-600 transition-all duration-300 whitespace-nowrap"
          >
            探索进球纪录
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 bg-white/15 text-white backdrop-blur-sm rounded-full text-sm font-medium hover:bg-white/25 transition-all duration-300 whitespace-nowrap"
          >
            了解本站
          </Link>
        </div>
      </div>
    </section>
  );
}